import React from "react";
import styled from "styled-components";
import {mobileUsual, tab} from "../../responsive";
const Container = styled.div`
  flex: 1;
  height: 70vh;
  position: relative;

`;
const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  ${mobileUsual({ height: "30vh" })}
`;
const Info = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  ${tab({ fontSize: "0.7rem" })}
`;
const Title = styled.h1`
  color: white;
  margin-bottom: 20px;
  
`;
const Button = styled.button`
  margin-top: 20px;
  cursor: pointer;
  border: none;
  color: white;
  padding: 20px;
  font-weight: 800;
  text-transform: uppercase;
  width: 200px;
  font-size: 17px;
  background-color: transparent;
  border: 5px solid white;
  transition: all 0.2 ease-out;
  border-radius: 5px;

  &:hover {
      background-color: white;
      color: black;
  }
`;

const CategoryItem = ({ item }) => {
  return (
    <Container>
      <Image src={item.img} />
      <Info>
        <Title>{item.title}</Title>
        <Button>Shop now</Button>
      </Info>
    </Container>
  );
};

export default CategoryItem;
